import React from 'react';
import useInView from './useInView';
import reveal from './reveal.module.css';
import styles from './QuienesSomos.module.css';

function QuienesSomos() {
  const [ref, inView] = useInView(0.2);

  return (
    <section id="quienes-somos" className={styles.section} ref={ref}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div
            className={`${styles.imageWrap} ${reveal.reveal} ${
              inView ? reveal.visible : ''
            }`}
          >
            <img
              src="/images/album1.png"
              alt="Equipo BCCY Colombia"
              loading="lazy"
              className={styles.image}
            />
          </div>

          <div
            className={`${reveal.reveal} ${inView ? reveal.visible : ''}`}
            style={{ transitionDelay: '0.15s' }}
          >
            <span className={styles.eyebrow}>Quiénes Somos</span>
            <h2 className={styles.title}>
              Un grupo empresarial con visión sostenible
            </h2>
            <p className={styles.text}>
              BCCY Colombia es un holding que integra distintas unidades de
              negocio bajo un mismo propósito: impulsar el desarrollo económico y
              social de las regiones donde operamos. Combinamos experiencia,
              solidez financiera y compromiso con la sostenibilidad.
            </p>
            <p className={styles.text}>
              Trabajamos de la mano con nuestros clientes y aliados para
              construir relaciones de largo plazo basadas en la confianza, la
              transparencia y la generación de valor compartido.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuienesSomos;